import { createDocValueStore } from './docStore';

// Phase 2's generated images are plain localStorage, not a reactive store, so nothing
// re-renders when they change on their own. These two module signals are how the
// phase-progress bar and the reader learn that they did:
//   - an EPOCH that bumps whenever a part's image is saved or the lot is wiped, used
//     as a recompute trigger for the coverage read;
//   - a BUSY flag mirrored from Phase 2 while it generates, so the phase shows as
//     running.
// Phase 2 runs on demand: one button generates every part (a small concurrency pool),
// and a column can be redone on its own. It is not part of the run-all sequencing.
const epochStore = createDocValueStore<number>(0);

// Signal that a document's generated images changed (a part was generated), so
// anything reading coverage re-reads it.
export function bumpImagesEpoch(docId: string) {
  epochStore.set(docId, epochStore.get(docId) + 1);
}

export const useImagesEpoch = epochStore.useValue;

// Whether Phase 2 is processing a part right now, mirrored to module scope by
// RealImagesStep so the phase-progress bar can show it as running.
const busyStore = createDocValueStore<boolean>(false);

export const setImagesBusy = busyStore.set;
export const useImagesBusy = busyStore.useValue;
